import React from 'react';
import * as Joi from 'joi-browser';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { getSkinFromStorageOrDefault } from '../../shared';
import { ROUTES, MAX_LENGTH_VARIABLES } from '../../const';

import Logo from '../common/Logo';
import CustomButton from '../common/CustomButton';
import $ from 'jquery';
import * as accountActions from '../../actions/accountActions';
import { smartLoaderService } from '../../services/domain/smartLoaderService';
import { redirect } from '../../utils/HttpUtils';
import { Input } from '@netexknowledge/smart-components';

const PASSWORD_MIN_LENGTH = 6;

export class Register extends React.Component {
  constructor(props) {
    super(props);
    this.title = '';
    this.onRegister = this.onRegister.bind(this);
    this.formSchema = Joi.object().keys({
      email: Joi.string()
        .email()
        .max(MAX_LENGTH_VARIABLES.EMAIL)
        .required(),
      name: Joi.string()
        .max(MAX_LENGTH_VARIABLES.NAME)
        .required(),
      surname: Joi.string()
        .max(MAX_LENGTH_VARIABLES.SURNAME)
        .required(),
      password: Joi.string()
        .max(MAX_LENGTH_VARIABLES.PASSWORD)
        .required(),
      repeatPassword: Joi.string()
        .max(MAX_LENGTH_VARIABLES.PASSWORD)
        .required(),
      institutionCode: Joi.string()
        .max(MAX_LENGTH_VARIABLES.SCHOOL_CODE)
        .required(),
      classCode: Joi.string().max(4)
    });
    this.state = {
      disableRegisterButton: false,
      name: '',
      nameError: false,
      surname: '',
      surnameError: false,
      email: '',
      emailError: false,
      password: '',
      passwordError: false,
      schoolCode: '',
      schoolCodeError: false,
      classCode: '',
      classCodeError: false
    };
  }

  componentDidMount() {
    const { accountActions } = this.props;
    accountActions.setFormError();
    $('#wrapperBackground').addClass('background-color-opaque-opacity');
    accountActions.setIndexTransition(true);
  }

  onRegister(e) {
    e.preventDefault();

    const { isAppOnline, redirectAfterLogin } = this.props;
    if (isAppOnline) {
      const { accountActions, enableEnrollment } = this.props;
      const { email, name, surname, password, schoolCode, classCode } = this.state;

      let user = {
        email: email,
        name: name,
        surname: surname,
        password: password,
        repeatPassword: password,
        institutionCode: schoolCode
      };

      if (enableEnrollment && classCode) {
        user.classCode = classCode;
      }

      if (this.validateForm(user)) {
        smartLoaderService.open();

        accountActions
          .signUp(user)
          .then(() => {
            redirect(window.location.origin + redirectAfterLogin).then(() => {
              accountActions.clearRedirectAfterLogin();
              smartLoaderService.close();
            });
          })
          .catch(() => {
            smartLoaderService.close();
          });
      }
    }
  }

  handleChange = (value, field, maxLength) => {
    const { accountActions } = this.props;
    const errorKey = field + 'Error';
    const stateUpdate = { [field]: value };

    if (value.length > maxLength) {
      stateUpdate[errorKey] = true;
      stateUpdate.disableRegisterButton = true;
      accountActions.setFormError(
        I18n.t('error.valueLength', {
          variable: I18n.t(`register.${field}`),
          length: maxLength
        })
      );
    } else {
      stateUpdate[errorKey] = false;
      stateUpdate.disableRegisterButton = false;
      accountActions.setFormError('');
    }

    this.setState(stateUpdate);
  };

  handleNameChange = event => {
    this.handleChange(event.target.value, 'name', MAX_LENGTH_VARIABLES.NAME);
  };

  handleSurnameChange = event => {
    this.handleChange(event.target.value, 'surname', MAX_LENGTH_VARIABLES.SURNAME);
  };

  handleEmailChange = event => {
    this.handleChange(event.target.value, 'email', MAX_LENGTH_VARIABLES.EMAIL);
  };

  handlePasswordChange = event => {
    this.handleChange(event.target.value, 'password', MAX_LENGTH_VARIABLES.PASSWORD);
  };

  handleSchoolCodeChange = event => {
    this.handleChange(event.target.value, 'schoolCode', MAX_LENGTH_VARIABLES.SCHOOL_CODE);
  };

  handleClassCodeChange = event => {
    this.handleChange(event.target.value, 'classCode', MAX_LENGTH_VARIABLES.CLASS_CODE);
  };

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && email.length <= MAX_LENGTH_VARIABLES.EMAIL;
  }

  missingFields(user) {
    const { accountActions } = this.props;
    let hasError = false;

    if (user.name.length < 1) {
      accountActions.setFormError(I18n.t('register.fieldRequiredError'));
      this.setState({ nameError: true });
      hasError = true;
    } else {
      this.setState({ nameError: false });
    }

    if (user.surname.length < 1) {
      accountActions.setFormError(I18n.t('register.fieldRequiredError'));
      this.setState({ surnameError: true });
      hasError = true;
    } else {
      this.setState({ surnameError: false });
    }

    if (user.email.length < 1) {
      accountActions.setFormError(I18n.t('register.fieldRequiredError'));
      this.setState({ emailError: true });
      hasError = true;
    } else {
      this.setState({ emailError: false });
    }

    if (!this.validateEmail(user.email)) {
      if (!hasError) {
        accountActions.setFormError(I18n.t('error.invalidEmail'));
      }
      this.setState({ emailError: true });
      hasError = true;
    }

    if (user.institutionCode.length < 1) {
      accountActions.setFormError(I18n.t('register.fieldRequiredError'));
      this.setState({ schoolCodeError: true });
      hasError = true;
    } else {
      this.setState({ schoolCodeError: false });
    }

    if (user.password.length < PASSWORD_MIN_LENGTH) {
      if (!hasError) {
        accountActions.setFormError(I18n.t('register.passwordLengthError'));
      }
      this.setState({ passwordError: true });
      hasError = true;
    } else {
      this.setState({ passwordError: false });
    }

    return !hasError;
  }

  validateForm(user) {
    const { accountActions } = this.props;

    if (!this.missingFields(user)) {
      return false;
    } else {
      accountActions.setFormError('');
      return true;
    }
  }

  formErrorHandler() {
    const { signUp } = this.props;

    return (
      <div className="error expand large-12 small-12 column text-center">
        <span>{signUp.formError}</span>
      </div>
    );
  }

  renderForm() {
    const {
      disableRegisterButton,
      nameError,
      surnameError,
      emailError,
      passwordError,
      classCodeError,
      schoolCodeError
    } = this.state;
    const theme = getSkinFromStorageOrDefault();
    const colors = theme.colors;

    return (
      <form className="column small-12" onSubmit={this.onRegister}>
        <div className="column xlarge-offset-2 xlarge-8 medium-offset-2 medium-8 small-12">
          <div className="large-6 medium-6 column" style={{ marginBottom: '24px', marginTop: '24px' }}>
            <Input
              type="text"
              value={this.state.name}
              onChange={this.handleNameChange}
              placeholder={I18n.t('register.name')}
              state={nameError ? 'error' : ''}
              data-cy="firstName"
            />
          </div>
          <div className="large-6 medium-6 column" style={{ marginBottom: '24px', marginTop: '24px' }}>
            <Input
              type="text"
              value={this.state.surname}
              onChange={this.handleSurnameChange}
              placeholder={I18n.t('register.surname')}
              state={surnameError ? 'error' : ''}
              data-cy="lastName"
            />
          </div>

          <div className="column">
            <div style={{ marginBottom: '24px' }}>
              <Input
                type="text"
                value={this.state.email}
                onChange={this.handleEmailChange}
                placeholder={I18n.t('register.email')}
                state={emailError ? 'error' : ''}
                data-cy="email"
              />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <Input
                type="password"
                value={this.state.password}
                onChange={this.handlePasswordChange}
                placeholder={I18n.t('register.password')}
                state={passwordError ? 'error' : ''}
                data-cy="password"
              />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <Input
                id="schoolCode"
                type="text"
                value={this.state.schoolCode}
                onChange={this.handleSchoolCodeChange}
                placeholder={I18n.t('register.schoolCode')}
                state={schoolCodeError ? 'error' : ''}
                data-cy="schoolCode"
              />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <Input
                id="classCode"
                type="text"
                value={this.state.classCode}
                onChange={this.handleClassCodeChange}
                placeholder={`${I18n.t('register.classCode')} ${I18n.t('common.optional')}`}
                state={classCodeError ? 'error' : ''}
                data-cy="classCode"
              />
            </div>
            <CustomButton
              color={colors.btnSuccess}
              colorHover={colors.btnSuccessHover}
              id="register-button"
              className="secondary button expanded"
              value={I18n.t('register.signUp')}
              manuallyDisabled={disableRegisterButton}
            />
          </div>
        </div>
      </form>
    );
  }

  render() {
    this.title = I18n.t('register.signUp');

    return (
      <div className="column xlarge-6 large-8 medium-10 small-12 content align-center">
        <div className="row box background-color-opaque align-center" id="wrapperBackground">
          <div className="row small-12 align-top">
            <div className="column small-12 text-center">
              <Logo customCss="logo-opaque" />
            </div>
            <h4 className="columns medium-12 text-center">{this.title}</h4>
            {this.formErrorHandler()}

            {this.renderForm()}
          </div>

          <div className="row align-self-bottom text-center">
            <Link to={ROUTES.LOGIN} data-cy="backToLogin">
              <p className="bottom-link"> {I18n.t('register.backToLogin')} </p>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

Register.propTypes = {
  role: PropTypes.string,
  isAppOnline: PropTypes.bool,
  signUp: PropTypes.object,
  accountActions: PropTypes.object,
  componentActions: PropTypes.object,
  enableEnrollment: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    signUp: state.signUp,
    role: state.signUp.role,
    i18n: state.i18n,
    isAppOnline: state.connection.status.online,
    redirectAfterLogin: state.router.redirectAfterLogin,
    enableEnrollment: state.account.configuration.enableEnrollment
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);
